import axios from 'axios';

import { coreApi } from '../api-client';
import { API_URLS } from '../config/api-urls';

// CoreApiMinimal is a singleton Without client interceptors
const CoreApiMinimal = axios.create({
  baseURL: API_URLS.CORE,
  withCredentials: true,
});

/**
 *  useCoreApi is a hook that returns a reusable axios instance with with a refresher for the core api
 */

const useCoreApi = () => {
  return coreApi;
};

export { coreApi, CoreApiMinimal, useCoreApi };
